import classNames from "classnames"
import React from "react"
import { Collapse } from "../../../ui/animations"
import { ExpandControl } from "../../../ui/atoms/IconButton/buttons/expand"
import Typography from "../../../ui/atoms/Typography"
import ConditionalLink from "../../../ui/utilities/ConditionalLink"
import { toLinkField } from "../../editorialPage/converters/link"
import classes from "./BrandEditorialMenuItem.module.css"

interface Props {
  item: any
  level: number
  defaultExpanded?: boolean
}

const getVariant = (style?: "title" | "subtitle") => {
  switch (style) {
    case "title":
      return "subtitle1"
    case "subtitle":
      return "body1"
    default:
      return "body2"
  }
}

const PADDING_UNIT = 8

const BrandEditorialMenuItem = ({ item, level, defaultExpanded }: Props) => {
  const link = item.link ? toLinkField(item.link) : undefined
  const [expanded, setExpanded] = React.useState(defaultExpanded ?? false)
  const hasSubitems = item.children?.length > 0

  const expandToggle = () => setExpanded(!expanded)
  return (
    <div
      style={{
        paddingLeft: level * PADDING_UNIT,
      }}
      className={classNames({
        [classes.title]: item.style === "title",
        [classes.subtitle]: item.style === "subtitle",
        [classes.default]: item.style === "default" || !item.style,
        [classes.withChildren]: hasSubitems,
      })}
      onClick={() => (!link?.url ? expandToggle() : undefined)}
    >
      <div className="flex justify-between">
        <ConditionalLink link={link?.url}>
          <Typography
            variant={getVariant(item.style)}
            weight="normal"
            uppercase
          >
            {item.label}
          </Typography>
        </ConditionalLink>
        <div>
          {hasSubitems && (
            <ExpandControl
              size={18}
              expanded={expanded}
              onClick={expandToggle}
            />
          )}
        </div>
      </div>
      {hasSubitems && (
        <Collapse in={expanded}>
          {item.children.map((x: any, i: number) => (
            <div key={i}>
              <BrandEditorialMenuItem item={x} level={level + 1} />
            </div>
          ))}
        </Collapse>
      )}
    </div>
  )
}

export default BrandEditorialMenuItem
